import * as React from "react";
const TechnologyDrivenOperationsSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect width={48} height={48} x={4} y={4} fill="#fff" rx={24} />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#DFE2EB"
      strokeWidth={8}
      rx={24}
    />
    <path
      fill="#2C2F38"
      d="M36.75 17.25h-17.5A1.75 1.75 0 0 0 17.5 19v17.5a1.75 1.75 0 0 0 1.75 1.75h17.5a1.75 1.75 0 0 0 1.75-1.75V19a1.75 1.75 0 0 0-1.75-1.75Zm-13.125 14a.874.874 0 1 1 0 1.749.874.874 0 0 1 0-1.749ZM19.25 19h3.5v10.65a2.625 2.625 0 1 0 1.75 0v-3.288l5.25 5.25V36.5h-10.5V19Zm17.5 17.5H31.5v-5.25a.875.875 0 0 0-.256-.62L24.5 23.889V19H28v2.625a.875.875 0 0 0 .256.62l1.75 1.75a2.625 2.625 0 1 0 1.238-1.237l-1.494-1.495V19h7v17.5Zm-4.375-12.25a.874.874 0 1 1 0 1.749.874.874 0 0 1 0-1.749Z"
    />
  </svg>
);
export default TechnologyDrivenOperationsSVG;
